import React, { Component } from 'react'
import StatusList from 'src/components/arrival-status-list-component/status-list-component';
// images
const bags_in_van = require('../../images/preslot_inbound_header.svg');
// styles
const styles = require('./ccd-in-progress.scss');

export enum BagsJourneyType {
  Collected = 1,
  InTransit = 2,
  InStorage = 3,
  OutOfStorage = 4,
  CheckedIn = 5,
  Downgraded = 6,
  WithCourier = 7,
  Delivered = 8,
  NotCollected = 9
}

export enum BagsJourneyStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  UrgentAttention = 4,
  PartiallyCompleted = 5
}

interface IProps {
  trackingData: any;
  language: string;
  multiLang: any;
}

export class ArrivalInProgressComponent extends Component<IProps, any> {
  render() {
    const { language, multiLang, trackingData } = this.props;
    const { arrivalPreCollectionTrackingStatus, bagsJourney } = trackingData;
    const title = multiLang[arrivalPreCollectionTrackingStatus.titleDisplay + language] || arrivalPreCollectionTrackingStatus.titleDisplay;
    const subtitle = multiLang[arrivalPreCollectionTrackingStatus.subTitle + language] || arrivalPreCollectionTrackingStatus.subTitle;
    const description = multiLang[arrivalPreCollectionTrackingStatus.text + language] || arrivalPreCollectionTrackingStatus.text;
    return (
      <div className={styles.mainContent}>
        <div className={styles.sectionWrapper}>
          <div className={styles.section}>
            <div className={styles.card}>
              <div className={styles.cardBody}>
                <h1 className={styles.heading}>{title}</h1>

                <div className={styles.group}>
                  <div>
                    <img src={bags_in_van} />
                    <h3 className={styles.subHeading}>
                      {subtitle}
                    </h3>
                    <p className={styles.description}>
                      {description}
                    </p>
                  </div>

                  <div>
                    <StatusList
                      bagsJourney={bagsJourney}
                      multiLang={multiLang}
                      language={language}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ArrivalInProgressComponent



// WEBPACK FOOTER //
// ./src/containers/ccd-in-progress/ccd-in-progress.component.tsx